/* eslint-disable @typescript-eslint/ban-types */
import { Action, Dispatch } from "redux";
import {
  CreateOutputConfigDetails,
  Environments,
  GetOutputConfigDetails,
  UpdateOutputConfigDetails
} from "@emisgroup/cohort-builder-kit";
import { setNotification } from "../../../../../utilities/HttpRequest/Script";
import { ProgressSpinnerSlice } from "../../../../ProgressSpinner/Index";
import { CreateScheduleSlice } from "../../../SchedulingConfiguration/CreateSchedule/redux";
import { OutputConfigPickerItem } from "../../../SchedulingConfiguration/OutputConfigPicker/Types";
import { CONFIGSAVE } from "../../Constant";
import { OutputConfigSlice } from "../../redux";
import { handleException } from "../../../../../ErrorMessages/helper";
import { PopulateConfigListTable } from "./Helper";

/**
 * To fetch the list of output configurations
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param extractGuid ID of the extract
 * @param isRequestFromPicker Is from output config picker
 */
export const FetchOutputConfigList = async (
  dispatch: Dispatch<Action>,
  translate: Function,
  extractGuid: string,
  env: Environments,
  accessToken: string,
  isRequestFromPicker?: boolean
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.OutputConfigList")));
    const res = await GetOutputConfigDetails(extractGuid, env, accessToken);
    if (res) {
      if (!isRequestFromPicker) {
        dispatch(OutputConfigSlice.actions.setConfigList(
          PopulateConfigListTable(JSON.stringify(res["data"]), dispatch))
        );
      }
      else {
        const data = res["data"] &&
          res["data"]["payload"] &&
          res["data"]["payload"].outputConfig;

        const updatedData: OutputConfigPickerItem[] = data?.map((data: any) => {
          return {
            outputConfigId: data?.outputConfigGuid,
            name: data?.name,
            xsdFileName: data,
            createdOn: data?.createdOn,
            createdBy: data?.createdBy,
            modifiedBy: data?.modifiedBy,
            modifiedOn: data?.modifiedOn,
            isValid: true
          };

        });
        dispatch(CreateScheduleSlice.actions.setPickerConfigList(updatedData));
      }
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex,dispatch, "GetOutConfigListErrMsg");
  }
};

/**
 * To save the output config
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param formData Contains Formdata
 * @param extractGuid ID of the extract
 */
export const saveOutputConfig = async (
  dispatch: Dispatch<Action>,
  translate: Function,
  formData: FormData,
  extractGuid: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.SaveConfig")));
    const response = await CreateOutputConfigDetails(formData as any, env, accessToken);
    if (response) {
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      setNotification(dispatch, CONFIGSAVE, translate("Notification.SaveConfig"), "success");
      FetchOutputConfigList(dispatch, translate, extractGuid, env, accessToken);
    }
  } catch (ex) {
    handleException(ex, dispatch, "OutputConfigErrMsg");
  }
};

/**
 * To update the output config
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param configId ID of the config
 * @param configName Name of the config
 */
export const updateOutputConfig = async (
  dispatch: Dispatch<Action>,
  translate: Function,
  configId: string,
  configName: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  const payload = {
    name: configName
  };
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.SaveConfig")));
    const response = await UpdateOutputConfigDetails(configId, payload, env, accessToken);
    if (response) {
      const updatedConfigName = response["data"] &&
        response["data"]["attributes"] &&
        response["data"]["attributes"]["outputConfigName"];
      if (updatedConfigName) {
        dispatch(OutputConfigSlice.actions.updateSelectedConfigName(updatedConfigName));
      }
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      setNotification(dispatch, CONFIGSAVE, translate("Notification.SaveConfig"), "success");
    }
  } catch (ex) {
    handleException(ex, dispatch, "EditOutputConfigErrMsg");
  }
};
